export default "__VITE_PUBLIC_ASSET__8ca9bc38__"